import { render, staticRenderFns } from "./BriqCheckbox.vue?vue&type=template&id=3d1b97d0&scoped=true&lang=pug&"
import script from "./BriqCheckbox.vue?vue&type=script&lang=js&"
export * from "./BriqCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BriqCheckbox.vue?vue&type=style&index=0&id=3d1b97d0&scoped=true&lang=stylus&"
import style1 from "./BriqCheckbox.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b97d0",
  null
  
)

export default component.exports